import { z } from 'zod';

/**
 * Listing note DTOs (SIL-1471, slice 1 of SIL-1470 arbitrage listings).
 * Spec: docs/superpowers/specs/2026-10-01-arbitrage-listings-design.md,
 * sections 3.4 and 8.
 *
 * Plain-text notes a seller org attaches to its OWN listing — visible only
 * to members of that owning org. `customer_org_id` and `authorClientUserId`
 * are always server-derived (migration 980's tg_listing_note_set_owner
 * trigger); this schema never accepts either from the client.
 */
export const createListingNoteInputSchema = z.object({
  body: z.string().trim().min(1).max(4000),
});
export type CreateListingNoteInput = z.infer<typeof createListingNoteInputSchema>;

export const updateListingNoteInputSchema = z.object({
  body: z.string().trim().min(1).max(4000),
});
export type UpdateListingNoteInput = z.infer<typeof updateListingNoteInputSchema>;

/**
 * GET/POST/PATCH /api/client/listings/:id/notes[/:noteId] response shape.
 * No `customerOrgId` — every row returned is already scoped to the
 * caller's own org (RLS + the route's own ownership check), and the field
 * would add nothing but a second place for it to disagree with the URL.
 */
export const listingNoteSchema = z.object({
  id: z.string().uuid(),
  listingId: z.string().uuid(),
  authorClientUserId: z.string().uuid().nullable(),
  /** True when the caller is also the author — drives edit/delete controls in the UI. */
  isOwnNote: z.boolean(),
  body: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ListingNoteDTO = z.infer<typeof listingNoteSchema>;
